import React from 'react';

const ManagerInsuranceCompaniesCaseTypesInsuranceSettingsIcon = () => {
	return (
		<svg viewBox='0 0 42 42' width={26} height={26} aria-hidden>
			<path
				fill='#1e40af'
				fillRule='evenodd'
				d='M27.113 21.784c.032-.256.057-.512.057-.784s-.025-.528-.057-.784l1.735-1.32a.396.396 0 0 0 .099-.512l-1.645-2.768a.419.419 0 0 0-.502-.176l-2.048.8a6.052 6.052 0 0 0-1.39-.784l-.312-2.12a.398.398 0 0 0-.403-.336h-3.29a.398.398 0 0 0-.403.336l-.313 2.12c-.501.2-.962.472-1.39.784l-2.047-.8a.406.406 0 0 0-.502.176l-1.645 2.768a.387.387 0 0 0 .099.512l1.735 1.32c-.033.256-.058.52-.058.784s.025.528.058.784l-1.735 1.32a.396.396 0 0 0-.099.512l1.645 2.768c.099.176.32.24.502.176l2.047-.8c.428.32.889.584 1.39.784l.313 2.12a.398.398 0 0 0 .403.336h3.29a.398.398 0 0 0 .403-.336l.312-2.12c.502-.2.962-.472 1.39-.784l2.048.8c.19.072.403 0 .502-.176l1.645-2.768a.396.396 0 0 0-.1-.512l-1.734-1.32zM21.002 23.8c-1.587 0-2.879-1.256-2.879-2.8 0-1.544 1.292-2.8 2.879-2.8s2.878 1.256 2.878 2.8c0 1.544-1.29 2.8-2.878 2.8z'
			/>
		</svg>
	);
};

export default ManagerInsuranceCompaniesCaseTypesInsuranceSettingsIcon;
